import { defineComponent as m, ref as h, computed as n, withDirectives as C, createElementBlock as b, openBlock as f, withModifiers as g, normalizeStyle as v, normalizeClass as k, renderSlot as y, createTextVNode as _, toDisplayString as T, unref as w } from "vue";
import { t as S } from "./tooltip-YeSRTnG0.js";
/* empty css                                                                   */
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = (t) => {
  let e = document.createElement("div");
  e.style.backgroundColor = t, document.body.appendChild(e);
  const r = window.getComputedStyle(e).backgroundColor;
  return e.remove(), e = null, r;
}, B = /* @__PURE__ */ m({
  __name: "HoverTile",
  props: {
    backgroundColor: {},
    title: { type: [String, Function] },
    tooltip: {},
    height: {},
    width: {},
    disabled: { type: Boolean },
    layoutColor: {}
  },
  emits: ["handleClick"],
  setup(t, { emit: e }) {
    const r = S, o = t, i = h(null), c = (l) => A(l) == "rgb(255, 255, 255)" ? o.layoutColor || "#A6A6A6" : o.backgroundColor, s = n(() => ({
      backgroundColor: o.backgroundColor,
      height: `${o.height}px`,
      width: `${o.width}px`,
      "--border-color": d.value
    })), d = n(() => c(o.backgroundColor)), a = e, p = () => {
      o.disabled || a("handleClick");
    };
    return (l, u) => C((f(), b("div", {
      ref_key: "hoverTile",
      ref: i,
      class: k(["hover-tile", { disabled: o.disabled }]),
      style: v(s.value),
      onClick: g(p, ["stop", "prevent"])
    }, [
      y(l.$slots, "content", {}, () => [
        _(T(t.title), 1)
      ], !0)
    ], 6)), [
      [w(r), {
        content: o.tooltip?.content,
        delay: [300, 0],
        theme: o.tooltip?.type
      }]
    ]);
  }
}), O = /* @__PURE__ */ x(B, [["__scopeId", "data-v-fc4b4a30"]]);
export {
  O as default
};
